import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useApi } from "@/components/common";
import { useT } from "@/i18n";

// Expandable full note history of a leadership task (every comment with author + time).
export function TaskThread({ taskId, count, v, testId }) {
  const [open, setOpen] = useState(false); const { t } = useT();
  const q = useApi(open ? `/exec/attention/tasks/${taskId}` : null, [open, taskId, v]);
  const rows = q.data?.comments || [];
  return <span className="inline-flex flex-col items-start" data-testid={`${testId}-thread`}>
    <button data-testid={`${testId}-thread-toggle`} onClick={() => setOpen(!open)} className="underline text-muted-foreground text-xs flex items-center gap-0.5">{open ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />}{t("exec.thread")}{count ? ` · ${count}` : ""}</button>
    {open ? <div className="mt-1 border-l-2 pl-2 space-y-1 text-xs max-h-48 overflow-y-auto w-full" data-testid={`${testId}-thread-list`}>
      {rows.map((c, i) => <div key={i} data-testid={`${testId}-thread-item-${i}`} className={c.blocker ? "text-red-700" : ""}><b>{c.by}</b> <span className="text-muted-foreground">{new Date(c.at).toLocaleString()}</span>{c.blocker ? " ⛔" : ""}<div>{c.text}</div></div>)}
      {q.data && !rows.length ? <div className="text-muted-foreground">{t("exec.no_notes")}</div> : null}
    </div> : null}
  </span>;
}
